import axios from "axios";
import { API_ENDPOINTS } from "../../../helpers/config";

export const UserService = {
  getAllUsers: async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL + API_ENDPOINTS.USER.GET_ALL
      );
      return response.data;
    } catch (err) {
      console.log(err);
    }
  },
};
